// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"vV","title":"vW"};